// extracted by mini-css-extract-plugin
export var boxItems = "_9s-1";
export var boxItemsLg = "_9s-2";
export var button = "_9s-7";
export var buttonHoverless = "_9s-9";
export var buttonLg = "_9s-8";
export var filterGroupBox = "_9s-0";
export var icon = "_9s-3";
export var iconSecondary = "_9s-6";
export var iconWrapper = "_9s-4";
export var iconWrapperLg = "_9s-5";
export var truncatedLabel = "_9s-a";